var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLeftArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.0002 6.99992L16.0002 8.99992L4.00016 8.99992L9.50016 14.4999L8.08016 15.9199L0.160156 7.99992L8.08016 0.0799214L9.50016 1.49992L4.00016 6.99992L16.0002 6.99992Z",
  fill: "#333333"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/left-arrow.f1173acf.svg";
export { ForwardRef as ReactComponent };